import Header from "../components/Header";

export default function Contribution() {
  return (
    <div className="min-h-screen bg-ivory text-ink">
      <Header variant="light" active="contribution" />
      <section className="pt-36 pb-12 px-6 lg:px-10 max-w-7xl mx-auto">
        <p className="text-5xl sm:text-6xl text-gold mb-2"><span className="font-headline italic text-[0.62em] mr-2">the</span><span className="font-sign">contribution</span></p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-4xl">LEGACY WELLNESS EQUITY FOR ALL</h1>
      </section>

      <section className="px-6 lg:px-10 max-w-7xl mx-auto pb-24">
        <div className="border-t border-gold/30 pt-10 max-w-3xl" data-testid="initiative-wellness-equity">
          <p className="eyebrow mb-4 !text-gold">Wellness Equity on the Edge</p>
          <p className="font-headline italic text-2xl lg:text-3xl text-ink/80 leading-snug">
            Empowerment, education and wellness experiences for underserved women and forgotten children, the orphans of the world.
          </p>
          <p className="mt-6 text-ink/70 leading-relaxed">
            Through our Business to Equity (B2E) model, the income and influence of empowered leaders and aligned organizations reach communities on the edge of society. A portion of proceeds from every LUXEWELL Experience supports this work.
          </p>
        </div>
      </section>
    </div>
  );
}
